import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TOMOS } from './salesData';
export function TomosSection() {
  return <section id="tomos" className="bg-charcoal pb-16 pt-14 text-white sm:py-20" data-id="element-215" data-mp="1kah8udyngvl2">
      <div className="mx-auto max-w-5xl px-5" data-id="element-216" data-mp="1p4c0q4oesgv8">
        <div className="text-center" data-id="element-217" data-mp="1u36j55igs3et">
          <p className="font-display text-[0.66rem] font-bold uppercase tracking-editorial text-gold" data-id="element-218" data-mp="1u257aytmjcw1">
            La colección
          </p>
          <h2 className="mx-auto mt-3 max-w-[22ch] font-display text-[1.7rem] font-extrabold leading-[1.1] tracking-tight sm:max-w-[30ch] sm:text-[2.5rem]" data-id="element-219" data-mp="11dzm6aynrlvo">
            No es un recetario suelto. Son{' '}
            <span className="text-gold" data-id="element-220" data-mp="1bbvuyw44i4qm">6 tomos que cubren todo el día.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-[46ch] font-sans text-[0.93rem] leading-relaxed text-white/75 sm:max-w-2xl sm:text-[1rem]" data-id="element-221" data-mp="2hs7up1mlfuob">
            Cada tomo resuelve un momento distinto de tu alimentación, para que nunca te quedes sin
            ideas. Todas las recetas son Keto y Sin TACC, con ingredientes que conseguís en
            Argentina.
          </p>
        </div>

        <ul className="mt-9 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-222" data-mp="2mkiwwyno7izq">
          {TOMOS.map((tomo, i) => <motion.li key={tomo.num} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 4) * 0.04
        }} className="flex h-full flex-col rounded-2xl bg-white/[0.07] p-4 ring-1 ring-white/10" data-id="element-223" data-mp="2hpdfod57qshz" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-224" data-mp="1ty7vxmw5jg2e">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gold font-display text-[0.78rem] font-extrabold text-charcoal" data-id="element-225" data-mp="1tzsqvdmdp10s">
                  {tomo.num}
                </span>
                <span className="font-display text-[0.6rem] font-bold uppercase tracking-editorial text-white/60" data-id="element-226" data-mp="1k24mrx2vuh5y">
                  Tomo {tomo.num} · {tomo.count}
                </span>
              </div>
              <h3 className="mt-3 font-display text-[1.02rem] font-bold leading-tight tracking-tight text-white" data-id="element-227" data-mp="11bhoxmr4qx7k">
                {tomo.name}
              </h3>
              <p className="mt-1.5 font-sans text-[0.82rem] leading-snug text-white/70" data-id="element-228" data-mp="15dle1e6q20bb">
                {tomo.desc}
              </p>
              <p className="mt-auto pt-3.5 font-display text-[0.58rem] font-bold uppercase tracking-editorial text-gold" data-id="element-229" data-mp="1t50c2urgtvgr">
                Keto + Sin TACC
              </p>
            </motion.li>)}
        </ul>

        <div className="mt-9 flex justify-center" data-id="element-230" data-mp="1obp8r3lv3wtl">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-231" data-mp="1oa4hbmuugtzy" />
        </div>
      </div>
    </section>;
}